"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const watch_handler_1 = require("../utils/browser/watch-handler");
class WatchService {
    constructor(apiSettings) {
        this.apiSettings = apiSettings;
        this.getWatchListHandler = this.getWatchList.bind(this);
        this.getItemSkuDetailsHandler = this.getSkuItemDetails.bind(this);
        this.addToWatchHandler = this.addToWatch.bind(this);
        this.removeFromWatchHandler = this.removeFromWatch.bind(this);
    }
    getWatchList() {
        return (0, watch_handler_1.getWatchListHandler)(this.apiSettings);
    }
    getSkuItemDetails(itemId) {
        return (0, watch_handler_1.getItemSkuDetailsHandler)(this.apiSettings, itemId);
    }
    addToWatch(itemDetails, listDetail, trackingData) {
        return (0, watch_handler_1.addToWatchHandler)(this.apiSettings, itemDetails, listDetail, trackingData);
    }
    removeFromWatch(itemDetails, listDetail, trackingData) {
        return (0, watch_handler_1.removeFromWatchHandler)(this.apiSettings, itemDetails, listDetail, trackingData);
    }
}
exports.default = WatchService;
